export const removeDateFromString = (stringVal) => {
  return stringVal.replace(/\/\d{4}-\d{2}-\d{2}$/, "");
};
